import WebsiteModel          from '@/models/services/website/WebsiteModel';
import WebsiteServiceModel   from '@/models/WebsiteServiceModel';
import doc                   from '@widesk-core/decorators/doc';

export default class WebsiteEntertainmentModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'tags[serviceUrn][tagReference]': id;
		'website.showUrn': Urn;
		'entertainmentUrn': Urn;
		'slugPrefix': id;
		'website': id;
		'websiteEntertainmentStatus': string;
		'search': string;
	};

	static get path(): string {
		return 'website_entertainments/{?id}';
	}

	@doc.string declare label: string;
	@doc.string declare slugPrefix: string;
	@doc.string declare entertainmentUrn: Urn;
	@doc.model(WebsiteModel) declare website: WebsiteModel;
}